import React from 'react';

export default function OptionGroupInput(props) {
  return <optgroup {...props} />;
}